
import React from 'react';
import { cn } from '@/lib/utils';

interface ConsumptionLegendProps {
  hideConsumption: boolean;
  onLegendClick: () => void;
  payload: any[];
}

const ConsumptionLegend: React.FC<ConsumptionLegendProps> = ({ 
  hideConsumption, 
  onLegendClick, 
  payload 
}) => {
  return (
    <ul className="flex flex-wrap justify-center gap-1 mb-0.5">
      {payload.map((entry: any, index: number) => (
        <li 
          key={`item-${index}`}
          className={cn(
            "flex items-center gap-0.5 cursor-pointer px-1 py-0.5 rounded-md transition-colors text-xs",
            hideConsumption 
              ? "opacity-60 bg-gray-100 dark:bg-gray-700" 
              : "bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/20 dark:hover:bg-blue-900/30 border border-blue-100 dark:border-blue-900/50"
          )}
          onClick={onLegendClick}
        >
          <span 
            className="inline-block w-2 h-2 rounded-full" 
            style={{ backgroundColor: entry.color }}
          />
          <span className="text-[10px] font-medium text-blue-700 dark:text-blue-300 truncate max-w-14">{entry.value}</span>
        </li>
      ))}
    </ul>
  );
};

export default ConsumptionLegend;
